/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/models/warenkorb-kategorie.ts.
 */
import {WarenkorbEntry} from './warenkorb-entry';

/**
 * Zweck: Beschreibt class WarenkorbKategorie und ihren Daten- oder Funktionsvertrag.
 */
export class WarenkorbKategorie {
  view_slug: string;
  label: string;
  positionen: WarenkorbEntry[];
}
